import React, { useState, useRef, useEffect } from "react";
import style from "./logCard.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";

const ReqLogCard = (props) => {

    const determineDate = date => {
        let current = new Date(date).toLocaleDateString('fa-IR')
        return current
    }

    return (
        <div className={style.wrapper}>
            <div className={style.flexWrapper}>
                <p className={style.index}>{toPersianNumber(props.id)}</p>
                <p className={style.name} onClick={() => props.handleComment(props.data)}>{props.data.content}</p>
                <p className={style.userName}>{determineDate(props.data.createDate)}</p>
                <p className={style.userDate}>{props.data.category}</p>
            </div>
        </div>
    );
}

export default ReqLogCard;
